import { Box, Typography } from '@mui/material';
import ContextualInfo from 'Components/ContextualInfo';
import useTranslate from 'Hooks/useTranslate';
import { OrganizationGuestUsersTable } from 'Page/Users/UsersTable';

interface Props {
  organization: IOrganization;
}

function TabGuestUsers({ organization }: Readonly<Props>) {
  const ts = useTranslate();

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box display="flex" alignItems="center">
        <Typography variant="h5" color="primary">
          {ts('page.organizationProfile.menu.GuestUsers')}
        </Typography>
        <ContextualInfo
          content={ts('page.organizationProfile.GuestUsersHelp')}
          role="GuestUsersHelp"
        />
      </Box>
      <OrganizationGuestUsersTable organizationCode={organization.code} />
    </Box>
  );
}

export default TabGuestUsers;
